import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import { useNavigate } from 'react-router-dom';

const StyledMobileDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.background.default,
  },
}));

const StyledMobileAppBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '0px',
}));

const StyledMobileTitle = styled(Typography)(() => ({
  flexGrow: 1,
}));

const StyledMobileDialogContent = styled(DialogContent)(() => ({
  padding: 0,
}));

const StyledMobileListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(2, 3),
}));

const StyledMobileButtonContainer = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(2, 3, 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

const StyledMobileButton = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  width: '100%',
}));

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  onOpenBookingDialog: () => void;
  scrollTo: (id: string) => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  open,
  onClose,
  onOpenBookingDialog,
  scrollTo
}) => {
  const navigate = useNavigate();

  return (
    <StyledMobileDialog fullScreen open={open} onClose={onClose}>
      <StyledMobileAppBar position="relative">
        <Toolbar>
          <StyledMobileTitle variant="h6" component="div">
            Menu
          </StyledMobileTitle>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="Sluit menu">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </StyledMobileAppBar>

      <StyledMobileDialogContent>
        <List>
          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("home")}>
              <ListItemText primary="Home" primaryTypographyProps={{ fontWeight: 700 }} />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />

          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("about")}>
              <ListItemText primary="Over ons" primaryTypographyProps={{ fontWeight: 700 }} />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />

          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("services")}>
              <ListItemText primary="Diensten" primaryTypographyProps={{ fontWeight: 700 }} />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />

          <StyledMobileButtonContainer disablePadding>
            <StyledMobileButton
              variant="outlined"
              color="primary"
              startIcon={<PersonOutlineRoundedIcon />}
              onClick={() => {
                onClose();
                navigate('/inloggen');
              }}
            >
              Mijn Pippaya / inloggen
            </StyledMobileButton>

            <StyledMobileButton
              variant="contained"
              color="secondary"
              onClick={() => {
                onOpenBookingDialog();
                onClose();
              }}
            >
              Reservering aanvragen
            </StyledMobileButton>
          </StyledMobileButtonContainer>
        </List>
      </StyledMobileDialogContent>
    </StyledMobileDialog>
  );
};

export default MobileMenu;
